import { render, staticRenderFns } from "./ProblemFeedbackEdit.vue?vue&type=template&id=3571356a"
import script from "./ProblemFeedbackEdit.vue?vue&type=script&lang=js"
export * from "./ProblemFeedbackEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports